module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAK5JREFUSA3tU9sNgCAMtMY5dB2dxDFkVKNzGGyNbYqvEAE/DCSkD+pde2BR/GZZa1vcE+7QRRgdCwPsYHJEv+E40M4AUBOGJlgwLgOB5XMk2LCjAQrywalULNNQjjtQ548uXdxVwacTOA3cdeQUeQRaIqc8S8RyvJbI944+fUXOf+DbIUtxZ5NPkIpg5olSEBB4zwRiSXO1jBzEcpKCU5M7gYnV8AkHCYZTMidQgRUwiJcwLQudjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/White/Chat.png
// module id = 657
// module chunks = 0